const formatToBRL = (value: string): string => {
  const valueToFormat = Number(value);

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(valueToFormat);
};

export default formatToBRL;
